export function CheckIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Check"
    >
      <path
        d="M13.1756 3.14929C13.5267 3.39922 13.6053 3.87984 13.3499 4.22349L7.06402 12.6825C6.92897 12.8651 6.72026 12.9781 6.48945 12.9973C6.25864 13.0165 6.0352 12.9324 5.87314 12.7738L2.7302 9.6978C2.42327 9.39741 2.42327 8.90958 2.7302 8.60919C3.03712 8.3088 3.53558 8.3088 3.8425 8.60919L6.33476 11.0484L12.0805 3.31751C12.3358 2.97386 12.8269 2.89696 13.178 3.14689L13.1756 3.14929Z"
        fill="currentColor"
      />
    </svg>
  );
}
